import React, { ReactNode } from 'react';
import { Stack, SxProps } from '@mui/material';

import { PoweredByWatermark, ScreenLoaderBackdrop } from '@ocx/ui';

export type AddCardIFrameBasedLayoutProps = {
  loading: boolean;
  children: ReactNode;
  sx?: SxProps;
};

export const AddCardIFrameBasedLayout = ({ loading, children, sx }: AddCardIFrameBasedLayoutProps) => (
  <>
    <ScreenLoaderBackdrop open={loading} />
    <Stack justifyContent="space-between" alignSelf="stretch" flexGrow="1" p={2} overflow="auto" sx={sx}>
      {children}
      <PoweredByWatermark />
    </Stack>
  </>
);
